module.exports = __webpack_public_path__ + "static/media/icon-quick-phone.f87100fd.svg";